import { api } from "./api";

/**
 * The blocklist credential the site scanner asks with.
 *
 * The key itself never travels back to the browser: the server answers whether
 * one is stored, never what it is. `cached` and `listed` are the honest stand-in
 * for a connection-test button - testing would mean spending a paid lookup on
 * somebody's domain, and what an operator actually wants to know is whether the
 * thing has been answering, which the cache already says.
 */
export interface WebRiskSettings {
  keySet: boolean;
  /** Name of the list, printed by the panel rather than hardcoded in it. */
  source: string;
  cached: number;
  listed: number;
  newestAt: string | null;
}

export const getWebRiskSettings = (): Promise<WebRiskSettings> =>
  api.get<WebRiskSettings>("/admin/ariregister/webrisk");

/** An empty string clears the stored key, which switches the lookup off. */
export const saveWebRiskSettings = (apiKey: string): Promise<{ ok: boolean }> =>
  api.put("/admin/ariregister/webrisk", { apiKey });
